const url = "https://backend.greenitmm.com/api/v1/";
const api = {
  getPromotions: url + "promotions",
  sendEmail: url + "sendEmail",
};

export default api;
